import React from 'react';
import { withRouter } from "react-router-dom";
import AppToolbar from './toolbar';
import AppDrawerMenu from './drawer-menu';
import AppDrawerSubMenu from './drawer-submenu';
import account from '../data/account';
const RoutableAppToolbar = withRouter(AppToolbar);
export default class AppLayout extends React.Component {
  render() {
    var accountModel = account.get();
    var title = 'PLUNK';
    if (accountModel.whiteLabel && accountModel.company) {
      title = accountModel.company.toUpperCase();
    }
    return /*#__PURE__*/React.createElement("app-layout", null, /*#__PURE__*/React.createElement("app-drawer-layout", {
      home: "/"
    }, /*#__PURE__*/React.createElement(RoutableAppToolbar, {
      authenticated: this.props.authenticated,
      search: this.props.search
    }), /*#__PURE__*/React.createElement("app-drawer", {
      "enable-submenu": "false"
    }, /*#__PURE__*/React.createElement("app-drawer-content", null, /*#__PURE__*/React.createElement("div", {
      className: "drawer-scrollable-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "drawer-toolbar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "toolbar-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "profile-mini-box"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "pointer primary"
    }, title)), /*#__PURE__*/React.createElement("i", {
      className: "material-icons pointer",
      "data-drawer-close-button": true
    }, "close"))), /*#__PURE__*/React.createElement(AppDrawerMenu, {
      role: this.props.role
    })), /*#__PURE__*/React.createElement(AppDrawerSubMenu, {
      role: this.props.role
    })))));
  }
}